import { useParams } from "react-router-dom";

// Resolves which language alias to redirect to when the URL doesn't
// already carry a valid one: the visitor's last-chosen language (from
// localStorage, the same key TopBar/MobileTopBar already write to), or
// "en" if that's missing, malformed, or no longer a valid active language.
export function getDefaultLangAlias(langs) {
  try {
    const stored = JSON.parse(localStorage.getItem("langFront"));
    if (stored && stored.langCode && langs && langs.length > 0) {
      const L = langs.find((l) => l.langCode === stored.langCode && l.active);
      if (L) return L.langCode;
    }
  } catch (e) {
    // ignore malformed localStorage value
  }
  return "en";
}

// For legacy (pre-language-prefix) URLs, which have no alias segment at
// all yet — just prepend one.
export function prependLangAlias(alias, pathname, search) {
  return `/${alias}${pathname}${search || ""}`;
}

// For switching language on an already-prefixed URL — swap out the first
// path segment (the old alias) for the new one, keeping the rest of the
// path and query string intact.
export function replaceLangAlias(alias, pathname, search) {
  const rest = pathname.replace(/^\/[^/]*/, "") || "";
  return `/${alias}${rest}${search || ""}`;
}

// Use from anywhere under the /:langAlias route tree to build
// alias-aware internal links/navigation targets, e.g.
// navigate(withLang("/cart")) or <Link to={withLang("/blog")}>.
export function useLangPath() {
  const { langAlias } = useParams();
  return (path) => {
    const suffix = path.startsWith("/") ? path : `/${path}`;
    return `/${langAlias}${suffix}`;
  };
}

// For building a storefront URL from OUTSIDE the /:langAlias tree —
// namely the admin panel's "view on site" style links, which have no
// langAlias route param to read. Pass the language the linked content
// itself is in (e.g. the medicine/blog's own langCode) when known; it
// falls back to the visitor's last-browsed language, then "en".
export function buildFrontendUrl(langCode, path) {
  const suffix = path.startsWith("/") ? path : `/${path}`;
  let alias = langCode;
  if (!alias) {
    try {
      const stored = JSON.parse(localStorage.getItem("langFront"));
      if (stored && stored.langCode) alias = stored.langCode;
    } catch (e) {
      // ignore malformed localStorage value
    }
  }
  return `/${alias || "en"}${suffix}`;
}
